import { css } from 'styled-components';
export const TouchedLabel = css `
  color: ${(props) => props.theme.blue};
  margin-top: -29px;
  font-size: ${(props) => props.theme.fontXXSmall};

  .label-background:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    background: white;
    height: 1px;
    width: 100%;
  }

  span {
    z-index: 10;
    position: relative;
  }
`;
export const TouchedInput = css `
  border: 1px solid ${(props) => props.theme.blue};
`;
